import "./home.scss";

export default function Home({setHomeLoaded}) {
    return (
        <div className="home sections-page sections-page-1" id="home">
            <div className="container home-landing-container">
                <div className="img-container">
                    <pre className="title-landing">
                        <img className="name-svg" src="/images/logos/jk-name-2.svg" alt="jk-name-2.svg"/>
                    </pre>
                    <div className="img-landing position-relative">
                        <img className="img-responsive img-front" src="/images/image9.png" alt="image9.png" onLoad={() => {setHomeLoaded(true)}}/>
                        <div className="socials-container d-none d-md-block">
                            <ul className="socials">
                                <li><a title="facebook" href="https://www.facebook.com/martianvin018/" target="_blank" rel="noreferrer"><i className="fab fa-facebook"></i></a></li>
                                <li><a title="instagram" href="https://www.instagram.com/kjkjkjkelvin/" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a></li>
                                <li><a title="linkedin" href="https://www.linkedin.com/in/johnkelvincalinisan/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="logo-container">
                    <object className="position-absolute logo-prl logo-1 to-left" data="/images/logos/j-front.svg"  alt="j-front.svg"  title="j-front.svg">  </object>
                    <object className="position-absolute logo-prl logo-2 to-right" data="/images/logos/k-front.svg"  alt="k-front.svg"  title="k-front.svg"> </object>
                    <object className="position-absolute logo-prl logo-3" data="/images/logos/jk-front.svg" alt="jk-front.svg" title="jk-front.svg"> </object>
                    <object className="position-absolute logo-prl logo-4 to-left" data="/images/logos/j-back.svg"   alt="j-back.svg"   title="j-back.svg" >  </object>
                    <object className="position-absolute logo-prl logo-5 to-right" data="/images/logos/k-back.svg"   alt="k-back.svg"   title="k-back.svg" > </object>
                    <object className="position-absolute logo-prl logo-6" data="/images/logos/jk-back.svg"  alt="jk-back.svg"  title="jk-back.svg">  </object>
                </div> 
                <div className="socials-container d-md-none">
                    <ul className="socials">
                        <li><a title="facebook" href="https://www.facebook.com/martianvin018/" target="_blank" rel="noreferrer"><i className="fab fa-facebook"></i></a></li>
                        <li><a title="instagram" href="https://www.instagram.com/kjkjkjkelvin/" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a></li>
                        <li><a title="linkedin" href="https://www.linkedin.com/in/johnkelvincalinisan/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>
            
            <div className="parallax-background"></div>  
        </div>
    )
}

